import script from "./StarsKikirpa.vue?vue&type=script&setup=true&lang=js"
export * from "./StarsKikirpa.vue?vue&type=script&setup=true&lang=js"

import "./StarsKikirpa.vue?vue&type=style&index=0&id=0ed9c478&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ed9c478"]])

export default __exports__